<div
  class="user-menu"
  [class.user-menu_is-collapsed]="isSideBarCollapsed()"
  appAddClassModifier
>
  <div class="user-menu__profile-image-container">
    <img
      class="user-menu__profile-image"
      [src]="getAdminProfilePicture()"
      alt="user"
    />
  </div>
  <div
    data-auto-id="toggleShowContentClick"
    class="user-menu__label-container"
    (click)="toggleShowContent()"
  >
    <div class="user-menu__label">
      {{ adminFullName() }}
    </div>
  </div>
  @if (showContent()) {
    <div
      bluClickOutside
      (clickedOutside)="setShowContent(false)"
      class="user-menu__content"
    >
      @if (isAllowedToEditPassword()) {
        <div
          data-auto-id="showEditPasswordModalClick"
          class="user-menu__item"
          (click)="showEditPasswordModal()"
        >
          <img
            src="assets/icons/user-menu/lock.svg"
            class="user-menu__item-image"
            alt="lock icon"
          />
          <div class="user-menu__item-label">Edit Password</div>
        </div>
      }
      <div
        data-auto-id="logoutClick"
        class="user-menu__item"
        (click)="logout()"
      >
        <img
          src="assets/icons/user-menu/logout.svg"
          class="user-menu__item-image"
          alt="logout icon"
        />
        <div class="user-menu__item-label">Logout</div>
      </div>
    </div>
  }
</div>
